export const TIER_REQUIREMENTS_MAP: Record<
  number,
  { tier: number; label: string; requirement: string; altRequirement?: string }
> = {
  0: { tier: 0, label: 'Pledge', requirement: '<10 reviews & 80% positive' },
  1: {
    tier: 1,
    label: 'Non-toxic I',
    requirement: '3+ reviews & 100% positive',
    altRequirement: 'or 10+ reviews & 90%',
  },
  2: {
    tier: 2,
    label: 'Non-toxic II',
    requirement: '30+ reviews & 95% positive',
  },
  3: {
    tier: 3,
    label: 'Non-toxic III',
    requirement: '50+ reviews & 98% positive',
  },
};

export const TIER_REQUIREMENTS = Object.values(TIER_REQUIREMENTS_MAP);
